import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  async function isImage(url: string, timeoutTime?: number): Promise<boolean> {
    // https://stackoverflow.com/questions/9714525/javascript-image-url-verify
    const IS_IMAGE = "success";
    const IS_NOT_IMAGE = "error";
    const IS_TIMEOUT = "timeout";

    const checkIsImage = new Promise((resolve, reject) => {
      const timeout = timeoutTime || 5000;
      let timer = new Image() as any;
      const img = new Image();
      img.src = url;
      timer.src = url;

      const imageIsError = () => {
        clearTimeout(timer);
        reject(new Error(IS_NOT_IMAGE));
      };

      img.onerror = () => imageIsError();
      img.onabort = () => imageIsError();
      img.onload = () => {
        clearTimeout(timer);
        resolve(IS_IMAGE);
      };
      timer = setTimeout(() => {
        reject(new Error(IS_TIMEOUT));
      }, timeout);
      // img.src = url;
    });

    try {
      const resultIsImage = await checkIsImage;
      if (resultIsImage === IS_IMAGE) {
        return true;
      }

      return false;
    } catch {
      return false;
    }
  }

  return {
    isImage,
  };
}
